import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import {
  loadSmses,
  deleteSms,
} from '../../../../../state/modules/smses/actions';
import { sendMessage } from '../../../../../state/actions';
import SmsesList from '../components/SmsesList';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.smses.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['smses', x]),
                schema.sms,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
    isLoading: state.smses.get('isLoading'),
    total: state.smses.get('total'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadSmses(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteSms(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  };
};

const SmsesListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsesList);

export default SmsesListContainer;
